(function (angular) {
    angular.module('bizPartEngage').controller('modules.media', mediaController);
    angular.module('bizPartEngage').controller('modules.mediatags', mediatagsController);

    mediaController.$inject = ["$rootScope", "modules.media.service", "$stateParams", "$state", "container", "$timeout", "$mdDialog", "MetadataService",
        "$filter", "bizCoreService", "$q", "$translate", "bizEngageService", "core.engage.service", "$scope", "$sce"];
    mediatagsController.$inject = ["modules.media.service", "$stateParams", "$state", "container", "$timeout", "$mdDialog", "MetadataService", "$filter", "bizCoreService", "$translate", "$rootScope", "$q", "bizEngageService"];

    function mediaController($rootScope, mediaService, $stateParams, $state, container, $timeout, $mdDialog, MetadataService, $filter, bizCoreService,
        $q, $translate, bizEngageService, engageService, $scope, $sce) {
        var vm = this;
        vm.MediaFiles = [];
        vm.MediaFileTypes = [];
        vm.SelectedTypes = [];

        vm.playClicked = false;
        vm.VideoPlaying = false;
        vm.Extended = false;
        vm.LikedExtended = false;
        vm.SeenExtended = false;
        vm.showLatest = false;
        vm.showMostLiked = false;
        vm.showMostViewed = false;
        vm.showMostCommented = false;
        vm.showRelated = false;
        vm.useJourneyOrder = journeySettings?.UseJourneyOrderInLists?.GetItemByValue('Key', 3)?.Value || false;

        vm.EventSource = "MEDIA";

        vm.fileId = ~~$stateParams.id;

		if (!vm.fileId)
			vm.fileUrlRewrite = $stateParams.id;

        vm.OnInit = OnInit;
        vm.OnPlay = OnPlay;
        vm.OnEnded = OnEnded;
        vm.GetMediaFiles = GetMediaFiles;
        vm.GetMediaFileTypes = GetMediaFileTypes;
        vm.GetFileImage = GetFileImage;
        vm.ToggleMediaTypes = ToggleMediaTypes;
        vm.PerformLikeAction = PerformLikeAction;
        vm.GetShowingSettings = GetShowingSettings;
        vm.InitSlick = InitSlick;
        vm.GetOneMediaFile = GetOneMediaFile;
        vm.GetRelatedMediaFiles = GetRelatedMediaFiles;
        vm.FilterLiked = FilterLiked;
        vm.GetYoutubeEmbedUrl = GetYoutubeEmbedUrl;
        vm.FilterAlreadyVisibleFiles = FilterAlreadyVisibleFiles;
        vm.PauseVideo = PauseVideo;
        vm.PlayVideo = PlayVideo;
        vm.PlayYoutube = PlayYoutube
        vm.YoutubePlayer = YoutubePlayer;
        vm.player;
        vm.GetFileTypeTranslations = GetFileTypeTranslations;
        vm.NavigateToMediaFile = NavigateToMediaFile;        

        function GetFileTypeTranslations(type) {
            if (!type)
                return;

            var value = type.FileType;
            var translation = type.NameOverrideTranslations.GetItemByValue('CultureId', $rootScope.LoggedInUser.CurrentCultureId);

            if (translation) {
                value = translation.Value;
            }
        
            return value;
        }
        
        function GetShowingSettings() {
            var settings = [];
            settings.push('showLatest');
            settings.push('showMostLiked');
            settings.push('showMostViewed');
            settings.push('showMostCommented');
            settings.push('showRelated');

            mediaService.GetGenericSettings(settings).then(LoadSettingsDone);

            function LoadSettingsDone(response) {
                console.log("LoadSettingsDone", response);
                vm.showLatest = (response.data.GetItemByValue('Key', 'showLatest').Value == 'true' ? true : false);
                vm.showMostLiked = (response.data.GetItemByValue('Key', 'showMostLiked').Value == 'true' ? true : false);
                vm.showMostViewed = (response.data.GetItemByValue('Key', 'showMostViewed').Value == 'true' ? true : false);
                vm.showMostCommented = (response.data.GetItemByValue('Key', 'showMostCommented').Value == 'true' ? true : false);
                vm.showRelated = (response.data.GetItemByValue('Key', 'showRelated').Value == 'true' ? true : false);
            }
        }

        function PauseVideo() {
        	vm.VideoPlaying = false;
        	var video = angular.element('#video-module-' + vm.MediaFile.Id);
        	video[0].pause();
        }

        function PlayYoutube() {            
        	vm.VideoPlaying = true;
        	vm.VideoEnded = false;
        	if (vm.player) {
        		var fn = function () { vm.player.playVideo(); }
        		setTimeout(fn, 1000);
        	}
        }

        function PlayVideo() {
        	vm.VideoPlaying = true;
        	vm.VideoEnded = false;
        	var video = angular.element('#video-module-' + vm.MediaFile.Id);
        	if (vm.VideoEnded) {
        		if (video.length) {
        			video[0].pause();
        			video[0].currentTime = '0';
        			video[0].play();
        			vm.PlayedVideo = true;
        		}
        	}
        	else {
        		if (video.length) {
        			video[0].play();
        			vm.PlayedVideo = true;
        		}
        	}
        }

        function YoutubePlayer(videoId) {            
        	var id = "youtube-" + vm.MediaFile.Id;
        	if (window.matchMedia("(min-width: 720px)").matches) {
        		vm.player = new YT.Player(id, {
        			width: '100%',
        			videoId: videoId,
                    playerVars: { rel: 0 },
        			events: {
        				'onStateChange': onPlayerStateChange
        			}
        		});
        	} else {
        		vm.player = new YT.Player(id, {
        			height: '100%',
        			width: '100%',
        			videoId: videoId,
                    playerVars: { rel: 0 },
        			events: {
        				'onStateChange': onPlayerStateChange
        			}
        		});
        	}
        }

    	// Youtube player change event...
        function onPlayerStateChange(event) {
            
        	if (event.data === -1) {
        		vm.OnPlay();
        	}
        	else if (event.data === 0) {
        		vm.VideoEnded = true;
        		vm.OnEnded();
        	}
        	else if (event.data === 3) {
        		// pause
        	}
        }

        function FilterAlreadyVisibleFiles(file) {
            if (file == undefined || vm.MediaFile == undefined) {
                return false;
            }

        	// remove other types?
        	if (file.Type != vm.MediaFile.Type) {
        		return false;
        	}

        	// remove current viewed file
        	if (file.Id == vm.MediaFile.Id) {
        		return false;
        	}

			// remove related files
        	if (vm.RelatedMediaFiles) {
        		for (var i = 0; i < vm.RelatedMediaFiles.length; i++) {
        			if (file.Id == vm.RelatedMediaFiles[i].Id) {
        				return false;
        			}
        		}
        	}
        		
        	return true;
        }

        function FilterLiked(a)
        {
            if (a.LikeActions.length == 1)
                return a.LikeActions[0].Count;

            if (a.LikeActions.length > 1)
                return TotalLikeActions(a);

            return 0;
        }

        function OnInit(source) {            
        	bizCoreService.EventInit(vm.MediaFile.Id, 14, vm.EventSource);

        	if (vm.MediaFile.Type == 1 && vm.VideoType == vm.VideoTypes.Youtube) {
        		setTimeout(function () {
        			vm.YoutubePlayer(GetYoutubeId(vm.MediaFile.FileUrl));
        		}, 0)
        	}
        }

        function OnPlay() {            
        	vm.playClicked = true;
        	bizCoreService.EventStart(vm.MediaFile.Id, 12, vm.EventSource);
        }

        function OnEnded() {            
        	bizCoreService.EventEnd(vm.MediaFile.Id, 13, vm.EventSource);
        }

        function GetFileImage(file)
        {
            switch(file.Type) {
                case 1:
                    return file.Thumbnail;
                case 2:
                    return file.FileUrl;
                default:
                    return file.Thumbnail;
            }
        }

        function ToggleMediaTypes(typeId) {
            if (vm.SelectedTypes.indexOf(typeId) > -1)
                vm.SelectedTypes.splice(vm.SelectedTypes.lastIndexOf(typeId), 1)
            else
                vm.SelectedTypes.push(typeId);

            if (vm.SelectedTypes.length == 0) {
                for (var i = 0; i < vm.MediaFileTypes.length; i++) {
                    vm.SelectedTypes.push(vm.MediaFileTypes[i].Id);
                }
            }

            vm.GetMediaFiles(vm.SelectedTypes, [], false, true);
        }

        function PerformLikeAction(item, action) {
        	if (!action.LikeActionPerformedByUser) {
                mediaService.AddLikeActionToMediaFile(item.Id, action.Action.Id).then(AddLikeActionToMediaFileSuccess);
            }

        	function AddLikeActionToMediaFileSuccess(response) {
        	    action.LikeActionPerformedByUser = true;
        	    action.Count++;

        	    var totalCount = 0;
        	    var totalValue = 0;

        	    for (var i = 0; i < item.LikeActions.length; i++) {
        	        totalCount += item.LikeActions[i].Count;
        	        totalValue += item.LikeActions[i].Action.Value * item.LikeActions[i].Count;
        	    }

        	    item.AverageLikeValue = totalValue / totalCount;
        	}
        }

        function GetLikeActionsByValue(entry, positive) {
            var result = 0;
            for (var i = 0; i < entry.LikeActions.length; i++) {
                if ((positive && entry.LikeActions[i].Action.Value > 0) || (!positive && entry.LikeActions[i].Action.Value < 0)) {
                    result += entry.LikeActions[i].Count;
                }
            }
            return result;
        }

        function TotalLikeActions(entry) {
            var count = 0;
            for (var i = 0; i < entry.LikeActions.length; i++) {
                count += entry.LikeActions[i].Count;
            }
            return count;
        }

        function GetOneMediaFile(fileId, urlRewrite) {
        	bizEngageService.GetObject(fileId > 0 ? fileId : urlRewrite, bizEngageService.Types.MediabankFile, true)
				.then(GetOneMediaFileSuccess);

            function GetOneMediaFileSuccess(response) {
                vm.MediaFile = response.data;
                
                if (vm.MediaFile.Tags && vm.showRelated) {
                    var tagIds = [];
                    for (var i = 0; i < vm.MediaFile.Tags.length; i++)
                    {
                        tagIds.push(vm.MediaFile.Tags[i].Id);
                    }
                    vm.GetRelatedMediaFiles(tagIds);    
                }

                MetadataService.setMetaTags({
                    title: vm.MediaFile.Name,
                    description: vm.MediaFile.Description,
                    img: vm.MediaFile.Thumbnail
                });
                
                if (vm.MediaFile.Type == 1) {
                    vm.VideoTypes = {
                        Native: 1,
                        Youtube: 2,
                        Vimeo: 3
                    };

                    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                    var match = vm.MediaFile.FileUrl.match(regExp);
                    if (match) {
                        vm.VideoType = vm.VideoTypes.Youtube;
                    }
                    else {
                        vm.VideoType = vm.VideoTypes.Native;
                    }
                }

                OnInit('GetOneMediaFileSuccess');
            }
        }

        function GetYoutubeEmbedUrl(url) {
        	return "https://www.youtube.com/embed/" + GetYoutubeId(url); // ?autoplay=1&controls=0
        }

        function GetYoutubeId(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url.match(regExp);

            if (match && match[2].length == 11) {
                return match[2];
            } else {
                return 'error';
            }
        }

        function InitSlick(overrideToShow) {
            vm.SlickLoaded = false;
            vm.SlickSettings = {
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: overrideToShow || 4,
                slidesToScroll: overrideToShow || 4,
                customPaging: function () {
                    return '<span class="biz-slick-dot biz-slick-square"></span>';
                },
                responsive: [{
                    breakpoint: 960,
                    settings: {
                        slidesToShow: vm.SlickOverrideResponsiveSlides || 2,
                        slidesToScroll: vm.SlickOverrideResponsiveSlides || 2,
                    }
                }]
            }
            $timeout(function () {
                vm.SlickLoaded = true;
            });
        }

        function GetRelatedMediaFiles(tagIds) {
            mediaService.GetMediaFiles([], tagIds, true).then(GetRelatedMediaFilesSuccess);
            function GetRelatedMediaFilesSuccess(response) {
                vm.RelatedMediaFiles = response.data;
                vm.InitSlick();
            }
        }

        function GetMediaFiles() {
            
            if (vm.SelectedTypes.length) {
                mediaService.GetMediaFiles(vm.SelectedTypes, [], false, true, vm.useJourneyOrder).then(GetMediaFilesSuccess);
            }
            else {
                vm.MediaFiles = [];
                vm.DataLoaded = true;
                console.error('No mediabank file types selected to show here...');
            }

            function GetMediaFilesSuccess(response) {
                vm.ItemsFetched = true;
                vm.MediaFiles = response.data;
                vm.DataLoaded = true;
                vm.InitSlick(2);
            }
        }

        function GetMediaFileTypes() {
            mediaService.GetMediaFileTypes().then(GetMediaFileTypesSuccess);
            function GetMediaFileTypesSuccess(response) {
                vm.MediaFileTypes = response.data;
                for (var i = 0; i < vm.MediaFileTypes.length; i++) {
                    vm.SelectedTypes.push(vm.MediaFileTypes[i].Id);
                }
                vm.GetMediaFiles([], [], false, true);
        	}
        }

        function NavigateToMediaFile(file) {
            return $state.go("base.modules.mediafile", { id: file.UrlRewrite || file.Id });
        }

        angular.element(document).ready(function () {
            $translate(['MEDIA.META.TITLE', 'MEDIA.META.DESCRIPTION']).then(function (translations) {
                MetadataService.setMetaTags({
                    title: translations['MEDIA.META.TITLE'],
                    description: translations['MEDIA.META.DESCRIPTION']
                })
            });            

            vm.GetShowingSettings();
            vm.GetMediaFileTypes();
        	if (!vm.fileId && !vm.fileUrlRewrite) {
                
                //vm.InitSlick();
            }
            else
                vm.GetOneMediaFile(vm.fileId, vm.fileUrlRewrite);

            bizEngageService.GetMiniJourneySetting('MediabankFile').then(function (response) {
                vm.MiniJourneySettings = response;
            });
        });        

        //disabled until vm.VideoEnded works properly, probably something to do with mediaplayer-directive that is used, need to connect the on-played-method, but cant get it to work...
        //$scope.$on("$destroy", function () {                        
        //    if (vm.MediaFile && vm.MediaFile.Type == 1 && !vm.VideoEnded) {                
        //        engageService.HandleEngageObjectCancelled(vm.MediaFile.Id, 'MediabankFile');//fire and forget
        //    }
        //});
    }

    function mediatagsController(mediaService, $stateParams, $state, container, $timeout, $mdDialog, MetadataService, $filter, bizCoreService, $translate, $rootScope, $q, bizEngageService) {
        var vm = this;

        vm.tagId = ~~$stateParams.tagId;
        vm.tagSystemName = $stateParams.tagSystemName;
        vm.fileId = $stateParams.fileId;
        vm.defaultFileTypes = $stateParams.fileTypes;
        vm.setFirstSelected = $stateParams.setFirstSelected;
        
        vm.EventSource = "MEDIA";

        vm.playClicked = false; // TODO: Same as vm.VideoPlaying
        vm.MediaFiles = [];
        vm.MediaFileTypes = [];
        if (!vm.defaultFileTypes) {
        	vm.defaultFileTypes = [];
        }

        vm.OnInit = OnInit;
        vm.OnPlay = OnPlay;
        vm.OnEnded = OnEnded;
        vm.VideoPlaying = false;

        vm.SelectedFile = undefined;
        vm.GetMediaFiles = GetMediaFiles;
        vm.GetFileImage = GetFileImage;
        vm.PerformLikeAction = PerformLikeAction;
        vm.GetTag = GetTag;
        vm.InitSlick = InitSlick;
        vm.SetSelectedFile = SetSelectedFile;
        vm.GetMediaFileTypes = GetMediaFileTypes;
        vm.GetYoutubeEmbedUrl = GetYoutubeEmbedUrl;
        vm.FilterAlreadyVisibleFiles = FilterAlreadyVisibleFiles;
        vm.FilterByTag = FilterByTag;
        vm.NavigateToMediaFileForTag = NavigateToMediaFileForTag;
        vm.PauseVideo = PauseVideo;
        vm.PlayVideo = PlayVideo;
        vm.PlayYoutube = PlayYoutube
        vm.YoutubePlayer = YoutubePlayer;
        vm.player;
        vm.GetFileTypeTranslations = GetFileTypeTranslations;

        function GetFileTypeTranslations(type) {
            if (!type.FileType)
                return;

            var value = type.FileType;
            var translation = type.NameOverrideTranslations.GetItemByValue('CultureId', $rootScope.LoggedInUser.CurrentCultureId);

            if (translation) {
                value = translation.Value;
            }

            return value;
        }

        function PauseVideo() {
        	vm.VideoPlaying = false;
        	var video = angular.element('#video-module-' + vm.SelectedFile.Id);
        	video[0].pause();
        }

        function PlayYoutube() {
        	vm.VideoPlaying = true;
        	vm.VideoEnded = false;
        	if (vm.player) {
        		var fn = function () { vm.player.playVideo(); }
        		setTimeout(fn, 1000);
        	}
        }

        function PlayVideo() {        	
        	vm.VideoPlaying = true;
        	vm.VideoEnded = false;
        	var video = angular.element('#video-module-' + vm.SelectedFile.Id);
        	if (vm.VideoEnded) {
        		if (video.length) {
        			video[0].pause();
        			video[0].currentTime = '0';
        			video[0].play();
        			vm.PlayedVideo = true;
        		}
        	}
        	else {
        		if (video.length) {
        			video[0].play();
        			vm.PlayedVideo = true;
        		}
        	}
        }

        function YoutubePlayer(videoId) {            
        	var id = "youtube-" + vm.SelectedFile.Id;
        	if (window.matchMedia("(min-width: 720px)").matches) {
        		vm.player = new YT.Player(id, {
        			width: '100%',
        			videoId: videoId,
                    playerVars: { rel: 0 },
        			events: {
        				'onStateChange': onPlayerStateChange
        			}
        		});
        	} else {
        		vm.player = new YT.Player(id, {
        			height: '100%',
        			width: '100%',
        			videoId: videoId,
                    playerVars: { rel: 0 },
        			events: {
        				'onStateChange': onPlayerStateChange
        			}
        		});
        	}
        }

    	// Youtube player change event...
        function onPlayerStateChange(event) {
        	if (event.data === -1) {
        		vm.OnPlay();
        	}
        	else if (event.data === 0) {
        		vm.VideoEnded = true;
        		vm.OnEnded();
        	}
        	else if (event.data === 3) {
        		// pause
        	}
        }

        function FilterByTag(file) {
            if (vm.tagId > 0 && file.Tags.length > 0) {
        		for (var i = 0; i < file.Tags.length; i++) {
        			if (file.Tags.length == 0) {
        				return false;
        			}

        			if (file.Tags[i].Id == vm.tagId) {
            //            if (vm.tagId == 9 && file.Type != 1) {
        				//	return false;
        				//}
        				return true;
        			}
        		}
        	}

        	return false;
        }

        function FilterAlreadyVisibleFiles(file) {
        	// remove other types?
        	if (file.Type != vm.SelectedFile.Type) {
        		return false;
        	}

        	// remove current viewed file
        	if (file.Id == vm.SelectedFile.Id) {
        		return false;
        	}

			// remove files with selected tagId
        	if (vm.tagId > 0 && file.Tags.length > 0) {
        		for (var i = 0; i < file.Tags.length; i++) {
        			if (file.Tags[i].Id == vm.tagId) {
        				return false;
        			}
        		}
        	}

        	return true;
        }

        function OnInit() {
        	if (vm.SelectedFile) {
        		bizCoreService.EventInit(vm.SelectedFile.Id, 14, vm.EventSource);

        		if (vm.SelectedFile.Type == 1 && vm.VideoType == vm.VideoTypes.Youtube) {
        			setTimeout(function () {
        				vm.YoutubePlayer(GetYoutubeId(vm.SelectedFile.FileUrl));
        			}, 0)
        		}
        	}
        }

        function OnPlay() {
        	vm.playClicked = true;
        	bizCoreService.EventStart(vm.SelectedFile.Id, 12, vm.EventSource);
        }

        function OnEnded() {            
        	bizCoreService.EventEnd(vm.SelectedFile.Id, 13, vm.EventSource);
        }

        function GetYoutubeEmbedUrl(url) {
        	return "https://www.youtube.com/embed/" + GetYoutubeId(url) + "?rel=0"; //  + '?autoplay=1' // &controls=0
        }

        function GetYoutubeId(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url.match(regExp);

            if (match && match[2].length == 11) {
                return match[2];
            } else {
                return 'error';
            }
        }

        function GetFileImage(file) {
            switch (file.Type) {
                case 1:
                    return file.Thumbnail;
                    break;
                case 2:
                    return file.FileUrl;
                    break;
                case 3:
                    break;
            }
        }

        function SetSelectedFile(file) {
        	vm.playClicked = false;

        	if (!file && vm.fileId) {

        		var idMatchIndex = -1;
        		var urlRewriteMatchIndex = -1;
        		var isNumeric = ~~vm.fileId;				

        		for (var i = 0; i < vm.MediaFiles.length; i++) {
        			var urlRewrite = vm.MediaFiles[i].UrlRewrite;
        			if (urlRewrite) {
        				if (urlRewrite.toLowerCase() == vm.fileId.toLowerCase()) {
        					urlRewriteMatchIndex = i;
        				}
        			}

        			if (isNumeric) {
        				if (~~vm.fileId == vm.MediaFiles[i].Id) {
        					idMatchIndex = i;
        				}
        			}
        		}

        		if (urlRewriteMatchIndex >= 0) {
        			file = vm.MediaFiles[urlRewriteMatchIndex];
        		} else if (idMatchIndex >= 0) {
        			file = vm.MediaFiles[idMatchIndex];
        		}
        	}

        	if (!file && vm.SelectedTag && vm.setFirstSelected)
            {
                for (var i = 0; i < vm.MediaFiles.length; i++) {
                    if (FilterByTag(vm.MediaFiles[i]) == true) {
                        vm.SelectedFile = vm.MediaFiles[i];
                        break;
                    }
                }
            }
            else if (file)
            {
            	vm.SelectedFile = file;
            }

            if (vm.SelectedFile && vm.SelectedFile.Type == 1) {
                vm.VideoTypes = {
                    Native: 1,
                    Youtube: 2,
                    Vimeo: 3
                };

                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = vm.SelectedFile.FileUrl.match(regExp);
                if (match) {
                    vm.VideoType = vm.VideoTypes.Youtube;
                }
                else {
                    vm.VideoType = vm.VideoTypes.Native;
                }
            }

            OnInit();

        }

        function NavigateToMediaFileForTag(file, state) {
        	var fileId = file.UrlRewrite;
        	if (!fileId) {
        		fileId = file.Id;
        	}

        	if (!state) {
        		state = "base.modules.mediatagsfileid";
			}
        	return $state.go(state, { tagSystemName: vm.tagSystemName, fileId: fileId });
        }

        vm.GetMediaFileUrl = GetMediaFileUrl;

        function GetMediaFileUrl(file, state) {
            var fileId = file.UrlRewrite;
            if (!fileId) {
                fileId = file.Id;
            }

            if (!state) {
                state = "base.modules.mediatagsfileid";
            }
            return $state.href(state, { tagSystemName: vm.tagSystemName, fileId: fileId });
        }

        function GetMediaFileTypes() {
            mediaService.GetMediaFileTypes().then(GetMediaFileTypesSuccess);
            function GetMediaFileTypesSuccess(response) {
                vm.MediaFileTypes = response.data;
                vm.GetMediaFiles();
            }
        }

        function InitSlick() {
            vm.SlickLoaded = false;
            vm.SlickSettings = {
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                customPaging: function () {
                    return '<span class="biz-slick-dot biz-slick-square"></span>';
                },
                responsive: [{
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }]
            }
            $timeout(function () {
                vm.SlickLoaded = true;
            });
        }

        function PerformLikeAction(item, action) {
        	if (!action.LikeActionPerformedByUser) {
                mediaService.AddLikeActionToMediaFile(item.Id, action.Action.Id).then(AddLikeActionToMediaFileSuccess);
            }

        	function AddLikeActionToMediaFileSuccess(response) {
        	    action.LikeActionPerformedByUser = true; // changed from item
        	    action.Count++;

        	    var totalCount = 0;
        	    var totalValue = 0;

        	    for (var i = 0; i < item.LikeActions.length; i++) {
        	        totalCount += item.LikeActions[i].Count;
        	        totalValue += item.LikeActions[i].Action.Value * item.LikeActions[i].Count;
        	    }

        	    item.AverageLikeValue = totalValue / totalCount;
            }
        }

        function GetTag() {
            var defer = $q.defer();
        	if (vm.tagSystemName) {
        		mediaService.GetTagBySystemName(vm.tagSystemName).then(GetTagSuccess);        		
        	} else {
        		mediaService.GetTag(vm.tagId).then(GetTagSuccess);
        	}
            
            function GetTagSuccess(response) {     
                vm.SelectedTag = vm.tagSystemName ? response.data : response.data[0];
                if (vm.SelectedTag != null) {
                    vm.tagId = vm.SelectedTag.Id;

                    MetadataService.setMetaTags({
                        title: vm.SelectedTag.Name,
                        description: vm.SelectedTag.Description
                    });
                }

                if (response.data == null) {
                    defer.resolve(false);
                }
                else {
                    defer.resolve(response);
                }
                
                vm.SetSelectedFile();
            }

            return defer.promise;
        }

        function GetMediaFiles() {        	
            var tagIds = vm.tagId ? [vm.tagId] : undefined;
            mediaService.GetMediaFiles(vm.MediaFileTypes.GetValues('Id'), tagIds, false).then(GetMediaFilesSuccess);
            function GetMediaFilesSuccess(response) {
                vm.MediaFiles = response.data;

                vm.SetSelectedFile();
                vm.InitSlick();
            }
        }

        angular.element(document).ready(function () {
            $translate(['MEDIA.META.TITLE', 'MEDIA.META.DESCRIPTION']).then(function (translations) {
                MetadataService.setMetaTags({
                    title: translations['MEDIA.META.TITLE'],
                    description: translations['MEDIA.META.DESCRIPTION']
                })
            });

            GetTag().then(function (response) {
                vm.GetMediaFileTypes();
            })

            bizEngageService.GetMiniJourneySetting('MediabankFile').then(function (response) {
                vm.MiniJourneySettings = response;
            });
        });               
    }
})(window.angular);
